export const css = {
	oneaction: '_2sQLSj4E',
	' _key': 'afcpe-theme/afcpe/quiz-widgets/prometric-review'
};

export default css;
